import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from 'angularfire2/firestore';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { TranslateService } from '@ngx-translate/core';
import { PrintServices } from '../services/printServices';
import { Globals } from '../../globals';
import firebase from 'firebase';
import { TakeawayServices } from '../takeaway/services';
import { OrdersCoServices } from '../orders/services';
import { NativeStorage } from '@ionic-native/native-storage';
import { AlertController, LoadingController } from 'ionic-angular';
import { NotificationsServices } from '../services/notificationsServices';

interface Order {
  UID: string;
  UID_RESTAURANT: string;
  hour: string;
  sections: any;
  show_kitchen: boolean;
  table: string;
  type: string;
  waiter: string;
  waiter_uid: string;
  updated_at: string;
}

interface Order_hidden {
  UID: string;
  UID_RESTAURANT: string;
  order_uid: string;
  user_uid: any;
}

@Injectable()
export class OrdersServices {

  ordersCol: AngularFirestoreCollection<Order>;
  orders: Observable<Order[]>;
  ordersfalse: Observable<Order[]>;
  orderDoc: AngularFirestoreDocument<Order>;
  ordersColPrint: AngularFirestoreCollection<Order>;
  orders_print: Observable<Order[]>;
  order: any;
  order_false: any;
  orders_array: any;
  orders_array_false: any;
  orders_number: number = 0;
  orders_array_print: any;
  orders_array_printed: any;
  orders_number_print: number = 0;
  public firestore: any;

  show_type: any = 'sections'; //sections - tags

  not_sound: boolean = false;

  sound_url: string = './assets/sound/alarm.mp3';

  //
  orders_hiddenCol: AngularFirestoreCollection<Order_hidden>;
  orders_hidden: Observable<Order_hidden[]>;
  order_hiddenDoc: AngularFirestoreDocument<Order_hidden>;
  orders_hidden_array: any;
  change_language: boolean = false;

  select_show = [
    { 'name': this.translate.instant('general-todos'), 'active': true },
    { 'name': this.translate.instant('general-aperitivos'), 'active': false },
    { 'name': this.translate.instant('general-primeros'), 'active': false },
    { 'name': this.translate.instant('general-segundos'), 'active': false },
    { 'name': this.translate.instant('general-postres'), 'active': false },
    { 'name': this.translate.instant('general-bebidas'), 'active': false },
    { 'name': this.translate.instant('general-combos'), 'active': false },
  ];
  active_sections = [this.translate.instant('general-todos')];

  old_orders = [];
  alert_old_orders: boolean = false;
  notify_old_orders: boolean = true;

  print_auto_on: boolean = false;
  print_hour: any;

  constructor(public afs: AngularFirestore,
    public translate: TranslateService,
    public printServices: PrintServices,
    public globals: Globals,
    private takeawayServices: TakeawayServices,
    public ordersCoServices: OrdersCoServices,
    private nativeStorage: NativeStorage,
    private alertCtrl: AlertController,
    public loadingCtrl: LoadingController,
    private notifServices: NotificationsServices) {
    this.firestore = firebase.firestore();
  }

  loadingPopup: any;
  presentLoading() {
    this.loadingPopup = this.loadingCtrl.create({
      spinner: 'crescent',
      content: ''
    });

    this.loadingPopup.present();
  }

  getOrdersShow(UID_RESTAURANT) {
    var _todos = this.select_show.find(item => item.name === this.translate.instant('general-todos'));
    if (_todos == undefined) { //Si _active es undefined, lo ponemos en activo para que aparezca la order
      const confirm = this.alertCtrl.create({
        title: '¡Atención!',
        message: 'Has cambiado el idioma en mitad del servicio. Es posible que los filtros no funcionen hasta acabar el servicio.',
        buttons: [
          {
            text: this.translate.instant('general-aceptar'),
            handler: () => {

            }
          },
        ]
      });
      confirm.present();
    }

    this.ordersCol = this.afs.collection('orders', ref => ref
      .where('UID_RESTAURANT', '==', UID_RESTAURANT)
      .where('show_kitchen', '==', true)
      .orderBy('updated_at', "desc")
    );
    this.orders = this.ordersCol.snapshotChanges().map(actions => {
      return actions.map(a => {
        const data = a.payload.doc.data() as Order;
        data.UID = a.payload.doc.id;
        /*var ms = new Date(new Date().toLocaleString()).getTime() - new Date(data.updated_at).getTime();
        var secs = (ms / 1000).toFixed(1)*/
        this.not_sound = true;
        if (this.not_sound) {
          this.sound();
        }
        return data;
      });
    });

    this.ordersCol.snapshotChanges().subscribe(value => {
      this.orders_array = [];
      this.orders_list_filtered_by_sections = [];
      this.orders_list_filtered_by_tags = [];
      value.map((a, index) => {
        const data = a.payload.doc.data() as Order;
        data.UID = a.payload.doc.id;
        this.orders_array.push(data);
        this.orders_number = 0;
        this.orders_number = this.orders_array.length;
        return data;
      });
      if (this.show_type == 'tags') {
        this.getOrdersFilteredByTags();
      } else {
        this.getOrdersFilteredBySections();
      }

    });

  }
  setSelectShow() {
    this.select_show = [
      { 'name': this.translate.instant('general-todos'), 'active': true },
      { 'name': this.translate.instant('general-aperitivos'), 'active': false },
      { 'name': this.translate.instant('general-primeros'), 'active': false },
      { 'name': this.translate.instant('general-segundos'), 'active': false },
      { 'name': this.translate.instant('general-postres'), 'active': false },
      { 'name': this.translate.instant('general-bebidas'), 'active': false },
      { 'name': this.translate.instant('general-combos'), 'active': false },
    ];
  }

  getOrdersHidden(UID_RESTAURANT, user_uid) {

    this.orders_hiddenCol = this.afs.collection('kitchen_hidden', ref => ref
      .where('UID_RESTAURANT', '==', UID_RESTAURANT)
      .where('user_uid', '==', user_uid)
    );
    this.orders_hidden = this.orders_hiddenCol.snapshotChanges().map(actions => {
      return actions.map(a => {
        const data = a.payload.doc.data() as Order_hidden;
        data.UID = a.payload.doc.id;
        return data;
      });
    });

    this.orders_hiddenCol.snapshotChanges().subscribe(value => {
      this.orders_hidden_array = [];
      value.map((a, index) => {
        const data = a.payload.doc.data() as Order_hidden;
        data.UID = a.payload.doc.id;
        this.orders_hidden_array.push(data);
        return data;
      });

    });

  }
  sound() {
    //sound
    let audio = new Audio();
    audio.src = this.sound_url;
    audio.load();
    audio.play();
    this.not_sound = false;
  }

  getOrdersShowFalse(UID_RESTAURANT) {
    this.ordersCol = this.afs.collection('orders', ref => ref.where('UID_RESTAURANT', '==', UID_RESTAURANT).where('show_kitchen', '==', false));
    this.ordersfalse = this.ordersCol.snapshotChanges().map(actions => {
      return actions.map(a => {
        const data = a.payload.doc.data() as Order;
        data.UID = a.payload.doc.id;
        return data;
      });
    });

    this.ordersCol.snapshotChanges().subscribe(value => {
      this.orders_array_false = [];
      value.map((a, index) => {
        const data = a.payload.doc.data() as Order;
        data.UID = a.payload.doc.id;
        this.orders_array_false.push(data);
        this.orders_number = 0;
        this.orders_number = this.orders_array.length;
        return data;
      });

    });

  }

  update(order) {
    this.sound_url = '';
    this.afs.collection('orders').doc(order.UID).update({
      sections: order.sections,
      show_kitchen: order.show_kitchen,
      table: order.table,
      type: order.type,
      waiter: order.waiter,
      waiter_uid: order.waiter_uid,
    }).then(() => {
      this.sound_url = './sound/alarm.mp3';
    });
  }

  async insertOrderHidden(UID_RESTAURANT, order_uid, user_uid) {
    await this.afs.collection('kitchen_hidden').add({
      'UID_RESTAURANT': UID_RESTAURANT,
      'order_uid': order_uid,
      'user_uid': user_uid,
    }).then(async ref => { });
  }


  showOrder(UID) {
    //delete ocular kitchen_hidden
    this.afs.doc('kitchen_hidden/' + UID).delete();
  }

  //variable array donde guardamos temporal las ordenes impresas
  orders_printed_no_duplicate: any = [];
  observer_orders_print: any;
  search_first_time: any = true;
  //Funcion que recupera todas la ordenes
  getOrdersShowPrint(UID_RESTAURANT) {
    this.orders_array_print = [];
    var date_time = new Date();

    this.observer_orders_print = this.firestore.collection('orders').where('UID_RESTAURANT', '==', UID_RESTAURANT)
      .where('show_kitchen', '==', true)
      .where('updated_at', '>=', date_time)
      .orderBy('updated_at', "desc")
      .onSnapshot(querySnapshot => {
        //querySnapshot recuperar solo las comandas nuevas 
        if (this.search_first_time == false) {
          //this.orders_array_print = [];
          querySnapshot.docChanges().forEach(change => {
            if (change.type === 'added') {

              var data = change.doc.data();
              data.UID = change.doc.id;
              data.kitchen_queue_print = 'printing';
              this.orders_array_print.unshift(data);
              this.printAll(data);
            }
            //
            if (change.type === 'removed') {
              var index = this.orders_array_print.findIndex(element => element.UID == change.doc.id);
              if (index > -1) {
                this.orders_array_print.splice(index, 1);
              }
            }
          });
        } else {
          this.search_first_time = false;
        }
      });
  }

  ordersPrinteSubscribe: any;
  getOrdersShowPrinted(UID_RESTAURANT) {

    this.ordersColPrint = this.afs.collection('orders', ref => ref
      .where('UID_RESTAURANT', '==', UID_RESTAURANT)
      .where('show_kitchen', '==', true)
      .orderBy('updated_at', "desc")
    );


    this.ordersPrinteSubscribe = this.ordersColPrint.snapshotChanges().subscribe(value => {
      this.orders_array_printed = [];
      value.map((a, index) => {
        const data = a.payload.doc.data() as Order;
        data.UID = a.payload.doc.id;
        this.orders_array_printed.push(data);
        return data;
      });

    });
  }

  async printAll(order) {
    this.printServices.prepareOrderKitchen('order', order, order, this.globals.restaurant.printer_type, 'kitchen');
    order.kitchen_queue_print = 'printed'
  }

  //Funcion que guarda en fb que una orden esta impresa
  async setOrderPrinted(order) {
    await this.afs.collection('orders').doc(order.UID).update({
      kitchen_queue_print: 'printed',
    });

  }

  /*SECTIONS*/

  orders_list_filtered_by_sections = [];
  //Funcion que devuelve las orders filtradas por las secciones elegidas por el usuario
  getOrdersFilteredBySections() {

    //recuperamos solo la seccion
    var _todos = this.select_show.find(item => item.name === this.translate.instant('general-todos'));
    if (_todos == undefined) { //Si _active es undefined, lo ponemos en activo para que aparezca la order
      _todos = { 'name': this.translate.instant('general-todos'), 'active': true }
    }
    var orders_array_tmp = JSON.parse(JSON.stringify(this.orders_array));
    var index_order = 0;
    //filtramos
    for (let order of orders_array_tmp) {
      var sections_list = [];
      var elements_combos = [];
      order.date = this.orders_array[index_order].date;
      index_order++;
      var index_section = 0;
      for (let section of order.sections) { //Recorrem les seccions

        var list_elements = [];
        var index_element = 0;
        for (let element of this.globals.objectToArray(section.list)) { //Recorrem els elements de la seccio
          element.index = index_element;
          if (element.tags == undefined) {
            element.tags = [];
          }
          //Si no filtramos
          if (!element.active && element.uid_combo_tmp == undefined) { //Si el tag de l'element esta dins l'array de tags activats
            //Añadimos el elemento dentro de l'array temporal del listado
            element.active = true;
            list_elements.push(element);
          }
          if (element.uid_combo_tmp >= 0 && !element.active) {
            element.active = true;
            if (section.name == 'Menu') {
              element.title_combo = element.name;
              element.section_index = index_section;
            }
            element.section_name = section.name;
            elements_combos.push(element);
          }
          index_element++;
        }
        if (list_elements.length > 0) { //Si hay algun elemento
          //Preparamos la seccion
          if (section.name != 'Menu') {
            var _active = this.select_show.find(item => item.name.toLowerCase() === section.name.toLowerCase());
            if (_active == undefined) { //Si _active es undefined, lo ponemos en activo para que aparezca la order
              _active = { 'active': true, 'name': section.name };
            }
            if (_active.active || _todos.active) {
              sections_list.push({ 'name': section.name, 'only_combo': section.only_combo, 'index': index_section, 'list': list_elements, 'ongoing': section.ongoing });
            }
          } else {
            if (_todos.active) {
              sections_list.push({ 'name': section.name, 'only_combo': section.only_combo, 'index': index_section, 'list': list_elements, 'ongoing': section.ongoing });
            }
          }

        }
        index_section++;
      }
      if (elements_combos.length > 0) {
        let combos_list = elements_combos.reduce((r, a) => {
          r[a.uid_combo_tmp] = [...r[a.uid_combo_tmp] || [], a];
          return r;
        }, {});
        combos_list = this.globals.objectToArray(combos_list);
        combos_list.forEach(element => {
          //Preparamos la seccion
          var _combos = this.select_show.find(item => item.name === this.translate.instant('general-combos'));
          if (_combos.active || _todos.active) {
            sections_list.push({ 'name': 'Menu', 'only_combo': true, 'index': index_section, 'list': element, 'ongoing': combos_list.ongoing });
          }
        });

      }
      if (sections_list.length > 0) { //Si hay alguna seccion
        //Preparamos la orden
        this.insertSectionInOrder(sections_list, order, 'sections');
        //if si estas en la modo print auto imprimir
        //convertir el timestamp de la order a date y compararlo con la date de la ultima vez que has entrado el la aplicacion
        //imprimir
        //actualizar la fecha
        if (this.print_auto_on) {
          if (this.print_hour <= new Date(this.globals.timestampToDate(order.date))) {
            this.printServices.prepareOrderKitchen('order', order, order, this.globals.restaurant.printer_type, 'kitchen');
            this.print_hour = new Date();
          }
        }

      }
    }
    this.checkOldOrders("sections");
    this.loadingPopup.dismissAll();
  }

  checkOldOrders(type) {
    var today = new Date()
    this.old_orders = [];
    today.setHours(0, 0, 0, 0);
    var order_arry = [];
    if (type == "sections") {
      order_arry = this.globals.objectToArray(this.orders_list_filtered_by_sections);
    } else {
      order_arry = this.globals.objectToArray(this.orders_list_filtered_by_tags);
    }
    this.alert_old_orders = false;

    order_arry.forEach(order => {
      if ((new Date(this.globals.timestampToDate(order.date)) < today) && (this.showOrHideOrder(order))) {
        this.old_orders.push(order);
        if (this.notify_old_orders) {
          this.alert_old_orders = true;
        }
      }
    });

    if (this.alert_old_orders && !this.globals.platform_mobile) {
      const alert = this.alertCtrl.create({
        title: this.translate.instant('general-atencion'),
        message: this.translate.instant("instant-alert-comandas-antiguas-borrar-ocultar"),
        buttons: [{
          text: this.translate.instant('general-aceptar'),
          role: 'cancel',
          handler: () => {

          }
        }]
      });
      this.notify_old_orders = false;
      alert.present();
    }
  }


  showOrHideOrder(order) {
    var show_order = false;
    if (this.orders_hidden_array) {
      var index = this.orders_hidden_array.findIndex(x => x.order_uid == order.UID);
      if (index >= 0) {
        show_order = false;
      } else {
        show_order = true;
      }
    } else {
      show_order = false;
    }
    return show_order;
  }

  insertSectionInOrder(sections_list, order, type) {
    //Guardamos las secciones seleccionadas para mostrar en las secciones de la orden
    order.sections = sections_list;
    this.insertOrderInListOrdersFiltered(order, type);
  }


  orders_list_filtered_by_tags = [];
  //Funcion que devuelve las orders filtradas por los tags elegidos por el usuario
  getOrdersFilteredByTags() {


    //Copiamos el array para no modificarla
    var orders_array_tmp = JSON.parse(JSON.stringify(this.orders_array));
    var _todos = this.ordersCoServices.active_tags.find(item => item === this.translate.instant('general-todos'));
    var index_order = 0;
    //filtramos
    for (let order of orders_array_tmp) {
      var sections_list = [];
      var elements_combos = [];
      order.date = this.orders_array[index_order].date;
      index_order++;
      var index_section = 0;
      for (let section of order.sections) { //Recorrem les seccions
        var list_elements = [];
        var index_element = 0;
        for (let element of this.globals.objectToArray(section.list)) { //Recorrem els elements de la seccio
          element.index = index_element;
          if (element.tags == undefined) {
            element.tags = [];
          }
          if (!_todos) {//Si filtramos
            for (let tag of element.tags) { //Recorrem els tags
              var has_tag = this.ordersCoServices.active_tags.find(item => item.toLowerCase() == tag.toLowerCase());
              if (has_tag && !element.active && element.uid_combo_tmp == undefined) { //Si el tag de l'element esta dins l'array de tags activats
                //Añadimos el elemento dentro de l'array temporal del listado
                element.active = true;
                list_elements.push(element);
              }
            }
          } else { //Si no filtramos
            if (!element.active && element.uid_combo_tmp == undefined) { //Si el tag de l'element esta dins l'array de tags activats
              //Añadimos el elemento dentro de l'array temporal del listado
              element.active = true;
              list_elements.push(element);
            }
          }
          if (element.uid_combo_tmp >= 0 && !element.active) {
            element.active = true;
            if (section.name == 'Menu') {
              element.title_combo = element.name;
              element.section_index = index_section;
            }
            element.section_name = section.name;
            elements_combos.push(element);
          }
          index_element++;
        }
        if (list_elements.length > 0) { //Si hay algun elemento
          //Preparamos la seccion
          sections_list.push({ 'name': section.name, 'only_combo': section.only_combo, 'index': index_section, 'list': list_elements, 'ongoing': section.ongoing });
        }
        index_section++;
      }
      if (elements_combos.length > 0) {
        let combos_list = elements_combos.reduce((r, a) => {
          r[a.uid_combo_tmp] = [...r[a.uid_combo_tmp] || [], a];
          return r;
        }, {});
        combos_list = this.globals.objectToArray(combos_list);
        combos_list.forEach(element => {
          //Preparamos la seccion
          sections_list.push({ 'name': 'Menu', 'only_combo': true, 'index': index_section, 'list': element, 'ongoing': combos_list.ongoing });
        });

      }
      if (sections_list.length > 0) { //Si hay alguna seccion
        //Preparamos la orden
        this.insertSectionInOrder(sections_list, order, 'tags');
        if (this.print_auto_on) {
          if (this.print_hour <= new Date(this.globals.timestampToDate(order.date))) {
            this.printServices.prepareOrderKitchen('order', order, order, this.globals.restaurant.printer_type, 'kitchen');
            this.print_hour = new Date();
          }
        }
      }
    }
    this.checkOldOrders("tags");
    this.loadingPopup.dismissAll();
  }



  insertOrderInListOrdersFiltered(order, type) {
    //Añadimos el customer/persons
    this.getPersonsOrCustomer(order);
    //Añadimos la imagen del delivery
    this.getDeliveryImage(order);

    if (type == 'sections') {
      this.orders_list_filtered_by_sections[order.UID] = order;
    } else {
      this.orders_list_filtered_by_tags[order.UID] = order;
    }
  }

  getPersonsOrCustomer(order) {
    var index = this.takeawayServices.tables_array_tk_kitchen.findIndex(x => x.UID == order.table_uid);

    //Añadimos el customer si la mesa tiene customer
    if (this.takeawayServices.tables_array_tk_kitchen[index] != undefined) {
      if (this.takeawayServices.tables_array_tk_kitchen[index].type == 'takeaway') {
        //Preparamos el customer de TK para order
        order.customer = { 'name': '', 'UID': '', 'phone': '', 'email': '', 'address': '' };

        order.customer.UID = this.takeawayServices.tables_array_tk_kitchen[index].customer_uid;
        order.customer.name = this.takeawayServices.tables_array_tk_kitchen[index].customer_name;
        order.customer.phone = this.takeawayServices.tables_array_tk_kitchen[index].customer_phone;
        order.customer.email = this.takeawayServices.tables_array_tk_kitchen[index].customer_email;
        order.customer.address = this.takeawayServices.tables_array_tk_kitchen[index].customer_address;

      } else if (this.takeawayServices.tables_array_tk_kitchen[index].type == 'table') {
        if (this.takeawayServices.tables_array_tk_kitchen[index].customer) {
          order.customer = this.takeawayServices.tables_array_tk_kitchen[index].customer;
        }
      }
      //Añadimos las persones
      order.persons = this.takeawayServices.tables_array_tk_kitchen[index].persons;
    }
  }

  getDeliveryImage(order) {
    //Comprovamos que la orden tenga un nombre de delivery
    if (order.delivery != undefined) {
      //Buscamos el delivery en la array
      const delivery = this.takeawayServices.deliveries.find(t => t.name == order.delivery);
      if (delivery != undefined) {
        //Guardamos la url de la imagen del delivery en la order
        order.delivery_img = delivery.img;
      }
    }
  }

  getShowType() {
    //Comprovamos si hay type seleccionado y ya lo activamos de inicio
    if (this.globals.checkLimitsByLicense('kitchen','categories')) { //miramos si la licencia tiene activo las categorias
      this.nativeStorage.getItem('show_type_kitchen')
        .then(
          data => {
            this.show_type = data;
          },
          error => {
            //Inicializamos con las sections
            this.nativeStorage.setItem('show_type_kitchen', this.show_type);
          });
    }
  }

  setActiveSections() {
    this.active_sections = [];
    for (let section of this.select_show) {
      if (section.active) {
        this.active_sections.push(section.name);
      }
    }
  }

  saveNative() {
    if (this.show_type == 'tags') {
      //si es estamos guardando tags
      //gardamos los tags en el nativeStorage
      this.nativeStorage.setItem('active_tags', JSON.stringify(this.ordersCoServices.active_tags)).then(item => {

      }, error => {
      });
      //y limpiamos selectes sections
      this.nativeStorage.setItem('active_sections', JSON.stringify([]));
      //Volvemos a filtrar los tags
      this.orders_list_filtered_by_tags = [];
      this.getOrdersFilteredByTags();
    } else {
      //si es estamos guardando sections las guardamos directamente en nativeStorage
      this.nativeStorage.setItem('active_sections', JSON.stringify(this.select_show));
      //y limpiamos selectes tags
      this.nativeStorage.setItem('active_tags', JSON.stringify([]));
      //Volvemos a filtrar las secciones
      this.orders_list_filtered_by_sections = [];
      this.getOrdersFilteredBySections();
    }
  }

  async callWaiter(order) {
    let _notification = {};
    let _user_auth = await this.globals.getUserAuthByUid(order.waiter_uid);

    //mirar si tiene user auth sino la notificacion queda en el limbo
    if (_user_auth != '' && _user_auth != undefined) {
      //por tipo
      if (order.type == "table") {//si es una mesa
        _notification = {
          'UID_RESTAURANT': this.globals.restaurant_uid,
          'UID_USER': _user_auth,//uid del waiter
          'title': this.translate.instant('notification-push-call-waiter'),
          'description': this.translate.instant('notification-push-call-waiter-table-desc') + " " + order.table,
        }
      } else if (order.customer != undefined) { //si es un tk normal de MCT
        _notification = {
          'UID_RESTAURANT': this.globals.restaurant_uid,
          'UID_USER': _user_auth,//uid del waiter
          'title': this.translate.instant('notification-push-call-waiter'),
          'description': this.translate.instant('notification-push-call-waiter-tk-desc-client') + " " + order.customer.name + " " + this.translate.instant('notification-push-call-waiter-tk'),
        }
      } else if (order.provider_code != "") {//si es de ordatic
        _notification = {
          'UID_RESTAURANT': this.globals.restaurant_uid,
          'UID_USER': _user_auth,//uid del waiter
          'title': this.translate.instant('notification-push-call-waiter'),
          'description': this.translate.instant('notification-push-call-waiter-tk-desc-client') + " " + order.provider_code + " " + this.translate.instant('notification-push-call-waiter-tk'),
        }
      } else {
        _notification = {//si no tiene ningun cliente asignado
          'UID_RESTAURANT': this.globals.restaurant_uid,
          'UID_USER': _user_auth,//uid del waiter
          'title': this.translate.instant('notification-push-call-waiter'),
          'description': this.translate.instant('notification-push-call-waiter-tk-desc-delivery') + " " + order.delivery,
        }
      }
      //Toast diciendo que la notificacion se ha enviado
      this.globals.launchToast(this.translate.instant('notification-push-call-waiter-ok'), 3000, 'top');
      //Enviamos la notificacion
      this.notifServices.notificationPushOneUser(_notification)
    } else {
      //Toast diciendo que este pedido no tiene camarero
      this.globals.launchToast(this.translate.instant('notification-push-call-waiter-no-waiter'), 5000, 'top');
    }
  }
}


// WEBPACK FOOTER //
// ./src/pages/kitchen/services.ts